// extracted by mini-css-extract-plugin
module.exports = {"atm_e2_1tcgj5g":"atm_e2_1tcgj5g","atm_vy_1tcgj5g":"atm_vy_1tcgj5g"};